import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUsb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUsb"><Path d="M10 5.5V7.5M14 5.5V7.5M3.5 10.5H20.5V21.5H3.5V10.5ZM5.5 2.5H18.5V10.5H5.5V2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUsb;
